export interface NumericMetricEntry {
  id: string;
  metricId: string;
  value: number;
  at: string;
  /** Jour civil explicite si présent en base (AAAA-MM-JJ). */
  recordedOn?: string;
}



/** Date locale « calendrier » pour un champ HTML date (AAAA-MM-JJ). */
export const localDateKey = (d: Date): string => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}



export const recordedOnKey = (entry: NumericMetricEntry): string => {
  if (
    entry.recordedOn &&
    /^\d{4}-\d{2}-\d{2}$/.test(entry.recordedOn)
  ) {
    return entry.recordedOn;
  }
  return new Date(entry.at).toISOString().slice(0, 10);
}



export const findNumericMetricEntryForDay = (entries: NumericMetricEntry[], metricId: string, ymd: string): NumericMetricEntry | undefined => {
  return entries.find(
    (e) => e.metricId === metricId && recordedOnKey(e) === ymd,
  );
}



export const parseNumericMetricEntries = (meta: unknown): NumericMetricEntry[] => {
  const root =
    meta && typeof meta === "object" && !Array.isArray(meta)
      ? (meta as Record<string, unknown>)
      : {};
  const priv =
    root.private && typeof root.private === "object" && !Array.isArray(root.private)
      ? (root.private as Record<string, unknown>)
      : {};
  const raw = priv.numericMetricEntries;
  if (!Array.isArray(raw)) return [];
  const out: NumericMetricEntry[] = [];
  for (const row of raw) {
    if (!row || typeof row !== "object") continue;
    const r = row as Record<string, unknown>;
    const id = typeof r.id === "string" ? r.id : "";
    const metricId = typeof r.metricId === "string" ? r.metricId : "";
    const value = typeof r.value === "number" ? r.value : Number(r.value);
    const at = typeof r.at === "string" ? r.at : "";
    const recordedOn =
      typeof r.recordedOn === "string" &&
      /^\d{4}-\d{2}-\d{2}$/.test(r.recordedOn)
        ? r.recordedOn
        : undefined;
    if (!id || !metricId || !Number.isFinite(value) || !at) continue;
    out.push({ id, metricId, value, at, recordedOn });
  }
  return out;
}
